/**
 * The host rules in src/hosts.js, bound to this page and this build's origins
 * (ADR-0062). The origins are build-time settings (frontend/origins.config.js),
 * prod's unless VITE_SITE_ORIGIN / VITE_APP_ORIGIN are set, as on staging.
 */
import { roleOf, hrefFor as hrefOn } from './hosts'

export const ORIGINS = {
  site: import.meta.env.VITE_SITE_ORIGIN,
  app: import.meta.env.VITE_APP_ORIGIN,
}

/** 'site', 'app', or null when served from neither (local dev). */
export function hereRole() {
  return roleOf(window.location.origin, ORIGINS)
}

/** The href for a link to `path` from this page. */
export function hrefFor(path) {
  return hrefOn(path, hereRole(), ORIGINS)
}
